export default __webpack_public_path__ + "static/media/delete.df9f65c5.svg";